import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Notifications from '@/views/notification/Notifications.vue';
import Footer from '@/views/footer/Footer.vue';
import Header from '@/views/header/Header.vue';
import { useLayout } from '@/composables/core/useLayout';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { setLayout, layout } = useLayout();

onMounted(async () => {
  window.addEventListener('resize', function () {
    setLayout();
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["layout flex flex-column w-full justify-content-between", `layout-${_unref(layout)}`])
  }, [
    _createVNode(_component_router_view),
    _createVNode(Footer),
    _createVNode(Header),
    _createVNode(Notifications)
  ], 2))
}
}

})